module.exports = __webpack_public_path__ + "media/images/athletes/122-b972a97e6677291369d7c69b41388046.png";